import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=28ec89e0&scoped=true"
var script = {}
import style0 from "./Conduct.vue?vue&type=style&index=0&id=28ec89e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec89e0",
  null
  
)

export default component.exports